import { useEffect, useState } from "react";
import {ServiceUtils} from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { useNavigate } from "react-router-dom";

export const useFiltersHook = () => {
      const navigate = useNavigate();
      const [medicaidFilters, setMedicaidFilters] = useState([]);
      const [statesList, setStatesList] = useState([]);
      const [drugClasses, setDrugClasses] = useState([]);
      const [meetingType, setMeetingType] = useState([]);
    useEffect(() => {
        fetchMedicaidFilters();
    }, [])

    const fetchMedicaidFilters = () => {
      ServiceUtils.getRequest("fetchDropdownData").then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
            let res = JSON.parse(JSON.stringify(response.data?.data));
            setMedicaidFilters(res);
          } else if (response.status === 401) {
            navigate("/logout");
          } else {
            alertService.error(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    };

    return medicaidFilters;
}

export const useMeetingsHook = (meetingFilters,view) => {
  const [meetings, setMeetings] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // if(view === 'agenda' && meetingFilters?.start && meetingFilters?.end) {
    //   fetchMeetings();
    // }
    // else if (view === 'month') {
    //   fetchMeetings();
    // }
    fetchMeetings();
  },[meetingFilters,view]);

  const fetchMeetings = () => {
    let payload = {};
    if(view && view === 'agenda') {
      payload = {
        ...meetingFilters,
        year : meetingFilters.year
      //   start: meetingFilters.start
      //   ? meetingFilters.start.format("YYYY-MM-DD")
      //   : null,
      // end : meetingFilters.end ? meetingFilters.end.format("YYYY-MM-DD") : null
      }
    } else {
         payload = {
          drugClasses: meetingFilters.drugClasses ,
          meetingType: meetingFilters.meetingType,
          states: meetingFilters.states,
          meetingStatus: meetingFilters.meetingStatus,
          // year: meetingFilters.year,
          agendaStatus: meetingFilters.agendaStatus,
          therapyClass: meetingFilters.therapyClass,
          view: view
         }
    }

    ServiceUtils.postRequest("medicaidConferencesInfo", payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let medMeetingsData = JSON.parse(
            JSON.stringify(response?.data?.data)
          );
          setMeetings(medMeetingsData);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  return meetings;
}

